import React, { useState } from 'react'
import Navbar from '../Components/Navbar'
import { motion } from 'framer-motion'
import Footer from '../Components/Foooter';
import PageHero from '../Components/PageHero'
import PageSEO from '../Components/SEO/PageSEO'
import { API_ENDPOINTS } from '../utils/GlobalAPI';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';
import PersistentCTA from '../Components/CRO/PersistentCTA'
import StickyMobileCTA from '../Components/CRO/StickyMobileCTA'

const Contactus = () => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    service: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess('');
    setError('');
    try {
      const res = await fetch(API_ENDPOINTS.CONTACT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.error || 'Failed to submit form');
      }
      setSuccess('Thank you! Your form has been submitted.');
      setForm({ name: '', phone: '', email: '', service: '' });
    } catch (err) {
      setError(err.message || 'Error submitting form');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageSEO 
        title="Contact Us – Cyborgsapient Pvt. Ltd. | Office Address, Phone & Email"
        description="Reach Cyborgsapient Pvt. Ltd. in Ramamurthy Nagar. Call +91 9164752256, email us, or visit our office for expert digital marketing, web development, and business solutions."
        keywords="contact cyborgsapient ramamurthy nagar, digital marketing company contact ramamurthy nagar, cyborgsapient contact number, cyborgsapient email"
        url="https://cyborgsapient.com/contact"
      />
      <Navbar/>
      <PageHero 
        title="Get In **Touch**"
        subtitle="Let's discuss how we can transform your business with our digital solutions"
      />
      
      {/* Contact Form Section */}
      <section className="py-16 sm:py-20 px-6 sm:px-8 lg:px-12 bg-white min-h-screen flex items-center">
        <div className="max-w-6xl mx-auto w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="space-y-8"
            >
              <div>
                <h2 className="text-4xl sm:text-5xl md:text-6xl font-light text-gray-900 mb-4 tracking-tight">
                  <span className="font-semibold">Let's Start</span><br />
                  a Conversation
                </h2>
                <p className="text-xl font-light text-gray-600 leading-relaxed">
                  Fill out the form and we'll get back to you within 24 hours to discuss your project needs.
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gradient-to-br from-orange-100 to-pink-100 rounded-xl">
                    <FaPhoneAlt className="text-orange-400" size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Phone</h3>
                    <p className="text-gray-600">+91 9164752256</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gradient-to-br from-pink-100 to-purple-100 rounded-xl">
                    <FaEnvelope className="text-pink-400" size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Email</h3>
                    <p className="text-gray-600">contact@cyborgsapient.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gradient-to-br from-purple-100 to-blue-100 rounded-xl">
                    <FaMapMarkerAlt className="text-purple-400" size={24} />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Location</h3>
                    <p className="text-gray-600">India</p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-white border border-gray-200 rounded-3xl p-8 md:p-12 shadow-lg"
            >
              <form onSubmit={handleSubmit} className="space-y-6">
                {success && (
                  <div className="p-4 bg-green-50 border border-green-200 rounded-xl text-green-700 font-medium text-center">
                    {success}
                  </div>
                )}
                {error && (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 font-medium text-center">
                    {error}
                  </div>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl !text-gray-900 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-transparent transition-all placeholder:text-gray-500"
                    style={{ color: '#111827' }}
                    placeholder="Your full name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl !text-gray-900 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-transparent transition-all placeholder:text-gray-500"
                    style={{ color: '#111827' }}
                    placeholder="+91 1234567890"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email ID</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl !text-gray-900 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-transparent transition-all placeholder:text-gray-500"
                    style={{ color: '#111827' }}
                    placeholder="your.email@example.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Service</label>
                  <select
                    name="service"
                    value={form.service}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl !text-gray-900 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-transparent transition-all"
                    style={{ color: '#111827' }}
                  >
                    <option value="">Select a service</option>
                    <option value="Search Engine Optimization (SEO)">Search Engine Optimization (SEO)</option>
                    <option value="Google Ads">Google Ads</option>
                    <option value="Facebook Ads">Facebook Ads</option>
                    <option value="YouTube Ads">YouTube Ads</option>
                    <option value="SMS Marketing">SMS Marketing</option>
                    <option value="Email Marketing">Email Marketing</option>
                    <option value="Content Marketing">Content Marketing</option>
                    <option value="WhatsApp Marketing">WhatsApp Marketing</option>
                    <option value="E-commerce Marketing">E-commerce Marketing</option>
                    <option value="UI/UX & Graphic Design">UI/UX & Graphic Design</option>
                    <option value="Social Media Development">Social Media Development</option>
                    <option value="Software Development">Software Development</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  disabled={loading}
                  className="w-full px-8 py-4 bg-gradient-to-r from-orange-300 via-pink-300 to-purple-300 text-white rounded-full font-medium hover:opacity-90 transition-opacity duration-200 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Submitting...' : 'Submit'}
                </motion.button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer/>
      <PersistentCTA />
      <StickyMobileCTA />
    </>
  )
}

export default Contactus

